import { render, staticRenderFns } from "./PaymentMethods.vue?vue&type=template&id=0c94d364&scoped=true&"
import script from "./PaymentMethods.vue?vue&type=script&lang=js&"
export * from "./PaymentMethods.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethods.vue?vue&type=style&index=0&id=0c94d364&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c94d364",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c94d364')) {
      api.createRecord('0c94d364', component.options)
    } else {
      api.reload('0c94d364', component.options)
    }
    module.hot.accept("./PaymentMethods.vue?vue&type=template&id=0c94d364&scoped=true&", function () {
      api.rerender('0c94d364', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/invoices/PaymentMethods.vue"
export default component.exports